import { useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa";
import { TbArrowBadgeLeft } from "react-icons/tb";
import "./Aside.css";
import { useDispatch, useSelector } from "react-redux";
import Header from "../header/Header.layout";
import { handleHambergerState } from "../../HandleSlice/HandleSlice";

const Aside = () => {
  const [asideData, setAsideData] = useState({});
  const data = useSelector((data) => data.hamberger);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const accordionTabRef = useRef();
  const [flag, setFlag] = useState(false);
  const [accordionState, setAccordionState] = useState("");
  const queryParameters = new URLSearchParams(window.location.search);
  const type = queryParameters.get("type");

  const subMenuDisplayHandler = (event, item) => {
    const element = accordionTabRef.current.childNodes;

    if (event.currentTarget.parentElement.className === "active") {
      for (let key of element) {
        key.classList.remove("noneActive");
        key.classList.add("active");
        key.childNodes[0].childNodes[1].className = "rotate-0";
      }
      event.currentTarget.childNodes[1].className = "rotate-90";
    }
    if (event.currentTarget.parentElement.classList.contains("active")) {
      event.currentTarget.parentElement.className = "noneActive";
      event.currentTarget.childNodes[1].className = "rotate-90";
    } else {
      event.currentTarget.parentElement.className = "active";
      event.currentTarget.childNodes[1].className = "rotate-0";
    }
  };

  const enterHoverHandler = (event) => {
    event.currentTarget.style.paddingRight = "10px";
  };
  const outHoverHandler = (event) => {
    event.currentTarget.style.paddingRight = "0px";
  };

  const asideHandler = (e) => {
    e.stopPropagation();
  };

  useEffect(() => {
    const localStorageData = JSON.parse(
      localStorage.getItem("home_admin_data"),
    );
    if (location.pathname !== "/login") {
      if (!localStorageData) {
        navigate("/");
      }
    }

    setAsideData(localStorageData);
  }, [setAsideData, data.DataState]);

  useEffect(() => {
    if (flag) {
      const ul = document.getElementsByClassName("all_UL");
      for (let key of ul) {
        if (
          type
            ? key.id ===
              "/" + accordionState.split("/")[1] + "?" + "type=" + type
            : key.id === "/" + accordionState.split("/")[1]
        ) {
          key.parentElement.parentElement.classList.remove("active");
          key.parentElement.parentElement.classList.add("noneActive");
        }
      }
    } else {
      setFlag(true);
    }
  }, [flag, accordionState]);

  useEffect(() => {
    dispatch(handleHambergerState(true));
  }, [location]);

  return (
    <>
      {asideData ? (
        <Header headerData={asideData.form && asideData.form.header} />
      ) : (
        <div className="flex justify-between items-center pr-[20px] pl-[20px] py-[10px] fixed left-0 right-0 top-0 bg-header_background dark:bg-[#D1D4C9] z-index 900:pr-[263px] 900:justify-between transition-all h-[60px]"></div>
      )}
      {asideData ? (
        <div
          className={
            "bg-aside_background_menu pb-[20px] dark:bg-gradient-to-b dark:from-[#556E53] dark:to-[#31463a] 900:block w-0 px-0 fixed right-[12px] 900:top-[12px] top-[84px] overflow-scroll 900:w-[248px] 900:px-4 900:bg-aside_background dark:900:bg-white z-10 transition-all scroll_hidden pt-[10px] rounded-lg max-h-[calc(100vh-30px)] mb-[20px] overflow-y-scroll"
          }
          style={
            data.hambergerState
              ? {}
              : {
                  width: "248px",
                  padding: "10px 20px 58px 20px",
                  zIndex: "1250",
                }
          }
          onClick={asideHandler}
        >
          <h2 className="text-aside_text text-[12px] dark:text-[#D1D4C9] py-3">
            پنل ادمین
          </h2>
          {
            <ul
              className="w-full text-aside_text dark:text-[#D1D4C9] category_ul flex flex-col gap-2"
              ref={accordionTabRef}
            >
              {asideData.form &&
                asideData.form.menu.map((item, index) => {
                  return (
                    item.access && (
                      <li
                        key={index}
                        className={`active`}
                        onMouseEnter={enterHoverHandler}
                        onMouseLeave={outHoverHandler}
                      >
                        {data.conectionFailedState &&
                        item.route !== undefined ? (
                          <NavLink
                            className={({ isActive }) => {
                              return data.conectionFailedState &&
                                isActive &&
                                !item.children
                                ? "flex items-center justify-between cursor-pointer py-2 transition-all ease-in-out delay-950 px-2 rounded-l-3xl bg-stone-600"
                                : "flex items-center justify-between cursor-pointer py-2 transition-all ease-in-out delay-950 px-2 rounded-l-3xl hover:bg-[#4d4d4d1c]";
                            }}
                            to={item.route}
                            onClick={(event) => {
                              subMenuDisplayHandler(event, item);
                              localStorage.removeItem("queryParams");
                            }}
                          >
                            <div className="flex items-center gap-2">
                              <span className={`text-[20px]`}>
                                <i className={`fa fa-${item.icon}`}></i>
                              </span>
                              <span>{item.label}</span>
                            </div>
                            <div>{item.children ? <FaAngleLeft /> : ""}</div>
                          </NavLink>
                        ) : (
                          <div
                            className="flex items-center justify-between cursor-pointer py-2 transition-all ease-in-out delay-950 px-2 rounded-l-3xl"
                            onClick={(event) => {
                              subMenuDisplayHandler(event, item);
                            }}
                          >
                            <div className="flex items-center gap-2">
                              <span className={`text-[20px]`}>
                                <i className={`fa fa-${item.icon}`}></i>
                              </span>
                              <span>{item.label}</span>
                            </div>
                            <div>{item.children ? <FaAngleLeft /> : ""}</div>
                          </div>
                        )}
                        <ul className="flex flex-col gap-2">
                          {item.children &&
                            item.children.map((item1, index) => {
                              return (
                                item1.access && (
                                  <li
                                    key={index}
                                    className="all_UL"
                                    id={
                                      data.conectionFailedState && item1.route
                                    }
                                  >
                                    <NavLink
                                      id_value={location.pathname}
                                      className={({ isActive }) => {
                                        if (isActive) {
                                          setAccordionState(location.pathname);
                                        }
                                        return data.conectionFailedState &&
                                          isActive
                                          ? "flex items-center gap-4 py-2 px-2 rounded-l-3xl bg-stone-600"
                                          : "flex items-center gap-4 py-2 px-2 rounded-l-3xl hover:bg-[#4d4d4d1c]";
                                      }}
                                      to={
                                        data.conectionFailedState && item1.route
                                      }
                                      onClick={()=>localStorage.removeItem("queryParams")}
                                    >
                                      <TbArrowBadgeLeft />
                                      {item1.label}
                                    </NavLink>
                                  </li>
                                )
                              );
                            })}
                        </ul>
                      </li>
                    )
                  );
                })}
            </ul>
          }
        </div>
      ) : (
        <div
          className={
            "bg-aside_background_menu dark:bg-gradient-to-b dark:from-[#556E53] dark:to-[#31463a] 900:block w-0 pb-[70px] px-0 fixed overflow-scroll h-full 900:w-[248px] 900:px-4 900:bg-aside_background dark:900:bg-white z-10 transition-all scroll_hidden pt-[80px]"
          }
        ></div>
      )}
    </>
  );
};

export default Aside;
